export default __webpack_public_path__ + "static/mission_report_video_thumbnail-c27173c9f03374a82140c25f72ea0e5a.jpg";